<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-info" @click.prevent="edit()">
        <i class="fas fa-pencil-alt mr-1"></i><span class="d-none d-lg-inline">Editar</span>
      </d-button>
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_USER_ } from '_modules/user/components/UserModel';

export default {
  name: 'user-buttons',
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_USER_, this.user);
    },
    edit() {
      this.$router.push(`/admin/usuarios/${this.user.id}`);
    },
  },
  mounted() {},
};
</script>
